import { render, staticRenderFns } from "./GridRecipe.vue?vue&type=template&id=7308da28&scoped=true&"
import script from "./GridRecipe.vue?vue&type=script&lang=js&"
export * from "./GridRecipe.vue?vue&type=script&lang=js&"
import style0 from "./GridRecipe.vue?vue&type=style&index=0&id=7308da28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7308da28",
  null
  
)

export default component.exports